import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { ProgressSpinner } from "primereact/progressspinner";
import { confirmDialog } from 'primereact/confirmdialog';
import { Image } from 'primereact/image';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import NoDataCreated from "../../../../../../Components/NoDataCreated";
import ErrorPage from "../../../../../../Components/ErrorPage";
import { goToTop } from "../../../../../../Components/goToTop";

import { useAppDispatch, useAppSelector } from "../../../../../../Controllers/hooks";
import { TenderSow } from "../../../../../../Controllers/Types/Tender/tenderSow";
import { getProjectTenderSowTemplateList } from "../../../../../../Controllers/Thunks/tenderThunks";
import { baseURL } from "../../../../../../Api/ApiConstant";
import { ProjectTenderDetailInterface } from "../../../../../../Controllers/Types/Tender/projectTenderDetailsInterface";

const SOW: React.FC = () => {
    const folderName = 'pre commencement';
    const serviceName = 'tender';
    const loadingPage = '';
    const error = '';

    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch()

    const tenderPart = location.state as ProjectTenderDetailInterface

    const toast = useRef<Toast>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [defaultSOWPage, setDefaultSOWPage] = useState<string>('template');
    // const [sowTemplatesData, setSowTemplatesData] = useState<SowTemplates[]>([]);
    const [tenderSowTemplateList, setTenderSowTemplateList] = useState<TenderSow[]>([]);

    const { loadingProjectTenderSow, } = useAppSelector((state) => state.tender);

    useEffect(() => {
        dispatch(getProjectTenderSowTemplateList());
    }, []);


      // this is get data from state list and set projectlist
      const tenderSowTemplate = useAppSelector(
        (state) => state.tender.tenderSowTemplateList
      );

      useEffect(() => {
        setTenderSowTemplateList(tenderSowTemplate);
    }, [tenderSowTemplate]);



    /* ******************************** Common functions ********************************** */
    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    const goBack = () => {
        navigate(-1);
        goToTop();
    };

    const handleViewSOWTemplate = (template: TenderSow) => {
        navigate(`/project/detail/default-service/pre-commencement/tender/sow/template`, { state: { pass_template: template, pass_tenderPart: tenderPart } });
    }
    /* *********************************************************************************** */

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {loadingProjectTenderSow ? (
                    <div className="loading_container">
                        <ProgressSpinner className="progresscircle custom" style={{ width: '50px', height: '50px', stroke: '#8953D7' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration="1s" />
                    </div>
                ) : error ? (
                    <ErrorPage errorMessage={error} />
                ) : (
                    <div className="page_content mt-0">
                        <div className="page_breadcrumb_area">
                            <ul className="page_breadcrumb">
                                <li className="page_breadcrumb_item has_child">{tenderPart.project_address}</li>
                                <li className="page_breadcrumb_item has_child">{folderName}</li>
                                <li className="page_breadcrumb_item has_child">{serviceName}</li>
                                <li className="page_breadcrumb_item text_purple">SOW</li>
                            </ul>

                            {/* <button className="back_btn p-ripple" onClick={goBack}>
                            <i className="bi bi-arrow-left me-2"></i>
                            Back
                            <Ripple />
                        </button> */}
                        </div>

                        <div className="page_header_area mt-3">
                            <div className="contact_tabs">
                                <div className="contact_tab_item">
                                    <button onClick={() => setDefaultSOWPage('template')} className="contact_tab_btn active p-ripple">
                                        SOW Template
                                        <Ripple />
                                    </button>
                                </div>

                                <div className="contact_tab_item">
                                    <Link to={'/project/detail/default-service/pre-commencement/tender/sow/customize'} state={tenderPart}
                                        className="contact_tab_btn p-ripple">
                                        SOW Custom
                                        <Ripple />
                                    </Link>
                                </div>
                            </div>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_main_content_section p-sm-3 p-xxl-4 p-xl-3 p-lg-3 p-2">
                            {tenderSowTemplateList?.length > 0 ? (
                                <div className="row sow_template_row">
                                    {tenderSowTemplateList?.map((template) => (
                                        <div key={template.template_tender_id} className="col-12 col-sm-6 col-lg-6 col-xl-4">
                                            <article className="sow_template p-ripple" style={{ backgroundColor: template.color }}
                                                onClick={() => handleViewSOWTemplate(template)}>
                                                <div className="temp_icon">
                                                    <img src={baseURL + template.logo} alt={template.name} />
                                                </div>
                                                <h6>{template.name}</h6>
                                                <Ripple />
                                            </article>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <NoDataCreated
                                    message={`There are no SOW templates!`}
                                />
                            )}
                        </div>

                    </div>
                )}
            </div >
        </React.Fragment>

    )
}

export default SOW;